export function resolveRoleDisplayName(role, locale, intl) {
  let name;
  if (role.titleDe || role.titleEn) {
    name = locale === "de" ? role.titleDe : role.titleEn;
  } else if (intl.messages["user.management.roles." + role.name]) {
    name = intl.formatMessage({ id: "user.management.roles." + role.name });
  } else {
    name = role.name;
  }

  return name;
}
